/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import {
  DeleteDeviceActions,
  DeleteDeviceActionTypes,
  deleteDeviceFailed,
  DeleteDeviceRequest,
  deleteDeviceSucceeded,
} from './action';
import { deleteDeviceQuery } from './deleteDeviceQuery';

export function deleteDeviceEpic(action$): Observable<DeleteDeviceActionTypes> {
  return action$.pipe(
    filter((action: DeleteDeviceActions) => action.type === DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST),
    switchMap(({ input }: DeleteDeviceRequest) =>
      deleteDevice(input).then(deleteDeviceSucceeded).catch(deleteDeviceFailed),
    ),
  );
}

export async function deleteDevice(input) {
  const graphQLClient = await setAuthenticatedClient();
  try {
    const { data } = await graphQLClient.mutate({
      mutation: deleteDeviceQuery,
      variables: { input },

      update: (cache) => {
        const deviceId = cache.identify({
          __typename: 'Terminal',
          id: input.id,
        });

        cache.evict({ id: deviceId });
        cache.gc();
      },
    });
    console.log('✅ Устройство удалено на сервере');

    return data;
  } catch (e) {
    console.log('Ошибка удаления устройства', e);
    throw new Error('Failed to delete device');
  }
}
